// import React from "react";
// import PropTypes from "prop-types";
// import { ArrowUpRight } from "lucide-react";

// export default function IconListCard({
//   title,
//   items = [],
//   loading,
//   emptyText = "Nothing to show yet.",
// }) {
//   if (loading) {
//     return (
//       <div className="card-soft p-4 icon-list-card">
//         <div className="skeleton w-100 h-100" />
//       </div>
//     );
//   }
//   console.log(items, "itemssss");

//   return (
//     <div className="card-soft p-4 icon-list-card">
//       <h6 className="fw-bold mb-3">{title}</h6>

//       {items.length === 0 && (
//         <p className="text-muted mb-0" style={{ fontSize: 13 }}>
//           {emptyText}
//         </p>
//       )}

//       {items.map((item) => (
//         <div
//           key={item.id}
//           className="d-flex align-items-center gap-3 mb-3 icon-list-row "
//         >
//           <img src={item.image} alt="img" className="icon-list-thumb" />
//           <div className="flex-grow-1">
//             <p
//               className="fw-semibold text-dark mb-0"
//               style={{ fontSize: 13.5 }}
//             >
//               {item.title}
//             </p>
//             {item.description && (
//               <p className="text-muted mb-0" style={{ fontSize: 12 }}>
//                 {item.description}
//               </p>
//             )}
//           </div>
//           <ArrowUpRight size={16} className="text-muted flex-shrink-0" />
//         </div>
//       ))}
//     </div>
//   );
// }

// IconListCard.propTypes = {
//   title: PropTypes.string.isRequired,
//   items: PropTypes.arrayOf(
//     PropTypes.shape({
//       id: PropTypes.string,
//       image: PropTypes.string,
//       title: PropTypes.string,
//       description: PropTypes.string,
//       link: PropTypes.string,
//     }),
//   ),
//   loading: PropTypes.bool,
//   emptyText: PropTypes.string,
// };
import React from "react";
import ProfileCardCarousel from "./ProfileCardCarousel";

export default function IconListCard(props) {
  return <ProfileCardCarousel {...props} />;
}
